import React from 'react';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
const filterConfig = [{
  id: 'search',
  type: 'text',
  label: 'Buscar',
  placeholder: 'Buscar por título ou mensagem...'
}, {
  id: 'lida',
  type: 'select',
  label: 'Status',
  placeholder: 'Filtrar por status...',
  options: [{
    value: '',
    label: 'Todas'
  }, {
    value: 'false',
    label: 'Não lidas'
  }, {
    value: 'true',
    label: 'Lidas'
  }]
}, {
  id: 'numeroCarga',
  type: 'text',
  label: 'Número da Carga',
  placeholder: 'Filtrar por número da carga...'
}, {
  id: 'numeroNota',
  type: 'text',
  label: 'Número da Nota',
  placeholder: 'Filtrar por número da nota...'
}];

const NotificacoesFilter = ({
  loading,
  onApply,
  onLimpar
}) => {
  return <FilterPanel filters={filterConfig} onApply={onApply} onLimpar={onLimpar} loading={loading} title="Filtros de Notificações" />;
};

export default NotificacoesFilter;